<template>
  <billing-list />
</template>

<script>
import BillingList from '@/components/Billing/BillingList'

export default {
  name: 'BillingListView',
  components: { BillingList },
}
</script>
